/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/json/common/json.nls.zh-cn", {
	"vs/base/common/json": [
		"符号无效",
		"数字格式无效",
		"需要属性名",
		"需要值",
		"需要冒号",
		"需要逗号",
		"需要右大括号",
		"需要右括号",
		"预期的文件结尾",
	]
});